(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/bets-context/assets/javascripts/bets-context-provider.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/bets-context/assets/javascripts/bets-context-provider.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useCallback = _React.useCallback;
const getPendingBets = svs.oddset_kambi.components.wapiIntegration.getPendingBets;
const BetsContext = svs.oddset_kambi.components.bets_context.BetsContext;
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
const throttle = (func, delay) => {
  let timerFlag = null; 

  return function () {
    if (timerFlag === null) {
      func(...arguments);
      timerFlag = setTimeout(() => {
        timerFlag = null;
      }, delay);
    }
  };
};
const BetsContextProvider = _ref => {
  let children = _ref.children;
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    numPendingBets = _useState2[0],
    setNumPendingBets = _useState2[1];
  const refreshPendingBets = useCallback(() => {
    getPendingBets();
  }, []);
  useEffect(() => {
    if (isLoggedIn) {
      refreshPendingBets();
    }
  }, [refreshPendingBets]);
  const value = useMemo(() => ({
    numPendingBets,
    refreshPendingBets,
    refreshPendingBetsThrottled: throttle(refreshPendingBets, 10000),
    setNumPendingBets
  }), [numPendingBets, refreshPendingBets, setNumPendingBets]);
  return React.createElement(BetsContext.Provider, {
    value: value
  }, children);
};
setGlobal('svs.oddset_kambi.components.bets_context.BetsContextProvider', BetsContextProvider);

 })(window);